<template>
    <div>
        <a-modal v-model="this.visible" :maskClosable="false" :closable="false">
            <slot></slot>
            <template slot="footer">
                <div class="modal-footer my-3">
                    <a-button class="w-full" type="danger" shape="round" ghost @click="this.handleCancel">
                        {{ cancelButtonText }}
                    </a-button>
                    <a-button v-if="this.showOkButton" class="w-full" type="primary" shape="round" @click="this.handleOk"
                        :disabled="this.modalProps.disabledOkButton">
                        {{ okButtonText }}
                    </a-button>
                </div>
                <div v-if="this.showResendCode" class="retry mt-5">
                    <p class="text-sm font-medium mb-1">¿No recibió el código?</p>
                    <p class="text-blue font-bold text-sm cursor-pointer mb-3" @click="this.handleResendCode">Enviar el código nuevamente</p>                     
                </div>

            </template>


        </a-modal>
    </div>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        handleOk: {
            type: Function,
            required: true
        },
        handleCancel: {
            type: Function,
            required: true
        },
        showResendCode: {
            type: Boolean,
            required: true
        },
        modalProps: {
            type: Object,
            required: true
        },
        handleResendCode: {
            type: Function,
            required: false
        },
        showOkButton: {
            type: Boolean,
            default: true
        },      
        okButtonText: {
            type: String,
            default: 'ENVIAR'
        },
        cancelButtonText: {
            type: String,
            default: 'CANCELAR'
        }
    },
    data() {
        return {
            isvisible: this.visible
        };
    },
    methods: {
    },
};
</script>

<style scoped>
.modal-footer {
    display: flex;
    justify-content: space-around;
    width: 90%;
    margin: 0 auto;
}

.retry {
    display: flex;
    flex-direction: column;     
    align-items: center;
    justify-content: center;
}
</style>
